import { z } from 'zod'

export const importPaymentsResponseSchema = z.object({
  count: z.number(),
})

export type ImportPaymentsResponseDto = z.infer<typeof importPaymentsResponseSchema>
